var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0516357,
    y: 11.0627,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.76794,
    y: 9.33398,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.4845,
    y: 7.60522,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.20105,
    y: 5.87671,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.9176,
    y: 7.60522,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63391,
    y: 9.33398,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3505,
    y: 11.0627,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.067,
    y: 12.7913,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7836,
    y: 11.0627,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4999,
    y: 9.33398,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2164,
    y: 7.60522,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9327,
    y: 5.87671,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6495,
    y: 4.14795,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3658,
    y: 2.41943,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0823,
    y: 0.690674,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7987,
    y: 2.41943,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5153,
    y: 4.14795,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2318,
    y: 5.87671,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5153,
    y: 7.60522,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7987,
    y: 9.33398,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0822,
    y: 11.0627,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3658,
    y: 12.7913,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6495,
    y: 14.52,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9327,
    y: 16.2485,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2164,
    y: 17.9773,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4999,
    y: 19.7061,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7836,
    y: 21.4346,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 12.067,
    y: 23.1633,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3505,
    y: 21.4346,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63391,
    y: 19.7061,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 6.9176,
    y: 17.9773,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 5.20105,
    y: 16.2485,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 3.4845,
    y: 14.52,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1.76794,
    y: 12.7913,
    width: 1.71648,
    height: 1.72866,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.3b997435fd3db02ec78109812ac7a741.svg";
export { ForwardRef as ReactComponent };